import { render } from "./PhoneOffOutline.vue?vue&type=template&id=c82d6c8e"
import script from "./PhoneOffOutline.vue?vue&type=script&lang=js"
export * from "./PhoneOffOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__